import { Link, useLocation } from "react-router-dom";

export default function ArkHeader() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <header
      data-testid="ark-header"
      className="w-full border-b border-[var(--ark-border)] bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="ark-brand-link"
          className="flex items-baseline gap-3 group"
        >
          <span className="font-display font-bold tracking-tight text-3xl md:text-4xl leading-none">
            ARK
          </span>
          <span className="hidden md:inline text-[0.7rem] uppercase tracking-[0.22em] text-[var(--ark-muted)] group-hover:text-[var(--ark-accent)] transition-colors">
            Furniture Customizer
          </span>
        </Link>
        <nav className="flex items-center gap-6 md:gap-10">
          <a
            href="/#categories"
            data-testid="nav-shop"
            onClick={(e) => {
              if (location.pathname === "/") {
                e.preventDefault();
                const el = document.getElementById("categories");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
            className="text-[0.72rem] uppercase tracking-[0.18em] text-[var(--ark-black)] hover:text-[var(--ark-accent)] transition-colors"
          >
            Shop
          </a>
          <a
            href="/#recent-transformations"
            data-testid="nav-gallery"
            onClick={(e) => {
              if (location.pathname === "/") {
                e.preventDefault();
                const el = document.getElementById("recent-transformations");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
            className="text-[0.72rem] uppercase tracking-[0.18em] text-[var(--ark-black)] hover:text-[var(--ark-accent)] transition-colors"
          >
            Gallery
          </a>
          {!isAdmin && (
            <Link
              to="/admin"
              data-testid="nav-admin"
              className="text-[0.72rem] uppercase tracking-[0.18em] text-[var(--ark-muted)] hover:text-[var(--ark-accent)] transition-colors"
            >
              Admin
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
